export default __webpack_public_path__ + "static/media/profilepicture.a0d336df.jpeg";